function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 6.9c0 .652 0 .978.074 1.285.065.272.173.532.319.77.165.27.395.5.857.961l2.4 2.4c1.056 1.056 1.584 1.584 2.193 1.782a2.667 2.667 0 001.648 0c.609-.198 1.137-.726 2.193-1.782l.632-.632c1.056-1.056 1.584-1.584 1.782-2.193a2.667 2.667 0 000-1.648c-.198-.61-.726-1.137-1.782-2.193l-2.4-2.4c-.46-.462-.691-.692-.96-.857a2.666 2.666 0 00-.771-.32C7.878 2 7.552 2 6.899 2h-.632c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C2 4.026 2 4.773 2 6.266V6.9z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 6.667a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#666A72"
  }, props), _ref, _ref2);
};

export default SvgLabel;